module.exports = __webpack_public_path__ + "img/qurantine-modal-bg.b62c980d.png";